export const de = {
  days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
  today: 'Heute',
  yesterday: 'Gestern',

  welcome: 'Willkommen',
  logout: 'Abmelden',
  settings: 'Einstellungen',

  THEME: {
    DARK: 'Dunkel',
    LIGHT: 'Hell',
  },

  PLACEHOLDER: {
    SEARCH_PLACEHOLDER: 'Suchen...',
    SELECT_OPTION: 'Option auswählen...',
    SELECT_STATUS: 'Status auswählen...',
    CHOOSE_STATUS: 'Status auswählen...',
    LOCATION: 'Geben Sie eine Stadt, Adresse oder einen Ort ein...',
    DESCRIPTION: 'Beschreibung des Vorfalls',
    AI_DESCRIPTION:
      'Beschreiben Sie, was, wo und wann passiert ist — z. B. Es gab ein kleines Feuer im Elektroraum in der Nähe der Balestier Road, Novena.',
    LOCATION_DESCRIPTION: 'Zusätzliche Details zum Standort',
    VALIDATING: 'Wird überprüft...',
    GENERATING: 'Wird generiert...',
  },

  CHAT_PANEL: {
    SEARCH_PLACEHOLDER: 'Suchen...',
    NO_MESSAGES_YET: 'Noch keine Nachrichten',
    IS_SPEAKING: 'spricht gerade...',
    ONLINE: 'online',
    OFFLINE: 'offline',
    TRANSCRIBING: 'Transkribiere...',
    NO_CHAT_FOUND: 'Keine Chats gefunden',
    NO_CHAT_SELECTED_TITLE: 'Kein Chat ausgewählt',
    NO_CHAT_SELECTED_DESCRIPTION:
      'Wähle einen Benutzer oder eine Gruppe aus der Seitenleiste, um eine Nachricht zu starten',
    INPUT_PLACEHOLDER_DEFAULT: 'Nachricht schreiben...',
    INPUT_PLACEHOLDER_WITH_ATTACHMENT: 'Füge eine Beschriftung hinzu...',
    IS_TALKING: 'redet...',
    PTT_ACTIVE: 'PTT Aktiv – Spricht...',
    PTT_LOCKED: 'PTT Gesperrt – Klick um freizugeben',
    PTT_SLIDE_HINT: 'Nach oben ziehen zum Sperren',
    PTT_RELEASE_AND_SEND: 'Loslassen & Senden',
    ATTACHED_FILES_TITLE: 'Angehängte Dateien',
    FAILED_TO_TRANSCRIBE_AUDIO: 'Transkription der Audio-Nachricht fehlgeschlagen',
    NO_CHAT_MESSAGE: 'Keine Chat-Nachricht',
    FALLBACK_MESSAGE: 'Um einen Chat zu starten, tippe deine Nachricht oder nutze die PTT/PTV Funktion.',
    INCOMING_VIDEO_CALL: 'Eingehender PTV...',
    SOMETHING_WENT_WRONG: 'Etwas ist schiefgelaufen',
    ERROR: 'Fehler:',
    NO_MESSAGES_FOUND_FOR: 'Keine Nachrichten gefunden für',
    SYSTEM_MESSAGE: 'Systemnachricht',
    GROUP: 'Gruppe',
    AUDIO: 'Audio',
    VIDEO: 'Video',
    FILE: 'Datei',
    ME: 'ich',
    IMAGE: 'Bild',
    TEXT: 'Text',
    CHAT: 'Chat',
    NONE: 'keine',
    PROFILE: 'Profil',
    SEARCH: 'Suchen',
    COMPLETED: 'abgeschlossen',
    RESOLVED: 'gelöst',
    USER_EMAIL_DOMAIN: '@widebridgecloud.com',
    UNKNOWN: 'Unbekannt',
    THEM: 'sie',
    HAS_ACCEPTED_THE_INCIDENT: 'heeft het incident geaccepteerd',
    INCIDENT_HAS_BEEN_UPDATED: 'Incident is bijgewerkt',
    INCIDENT_HAS_BEEN_RESOLVED: 'Incident is opgelost',
    YOU_HAVE_JOINED_THE_GROUP: 'Je bent lid geworden van de groep',
  },

  PROFILE_PANEL: {
    MEMBERS_LABEL: 'Mitglieder',
    GROUP_MEMBERS_TITLE: 'Gruppenmitglieder',
    USERNAME_LABEL: 'Benutzername',
    EMAIL_LABEL: 'E-Mail',
    MEMBER_FALLBACK_NAME: 'Mitglied',
    MEMBER_FALLBACK_ID: 'Mitglied',
  },

  PTT: {
    AUDIO: {
      FILENAME_PREFIX: 'ptt-audio-',
      FILE_TYPE: 'audio/webm',
      FILE_EXTENSION: '.webm',
    },
    MESSAGES: {
      START_RECORDING: 'PTT-Aufnahme gestartet für {{userName}}',
      STOP_RECORDING: 'PTT-Audio an {{userName}} gesendet',
      NO_AUDIO_DATA: 'Keine Audiodaten vom SDK erhalten',
      TRANSCRIPTION_SUCCESS: 'Audiotranskription abgeschlossen',
      TRANSCRIPTION_FAILED: 'Transkription fehlgeschlagen, Audio ohne Text gesendet',
    },
    TRANSCRIPTION: {
      MODEL: 'whisper-1',
      LANGUAGE: 'de',
      RESPONSE_FORMAT: 'text',
    },
  },

  CHAT_WINDOW: {
    SEARCH_IN: 'Suchen in',
    YOUR_PROFILE: 'Dein Profil',
    VIEW_PROFILE: 'Profil anzeigen',
    PIN_CHAT: 'Chat anheften',
    UNPIN_CHAT: 'Chat lösen',
    MUTE_CHAT: 'Chat stummschalten',
    UNMUTE_CHAT: 'Stummschaltung aufheben',
  },

  DASHBOARD: {
    INCIDENTS: 'Vorfälle',
    INCIDENTS_NO_DATA: 'Um einen Vorfall zu erstellen, klicken Sie auf die Schaltfläche "+ Vorfall erstellen"',
    RESPONDERS: 'Einsatzkräfte',
    RESPONDERS_NO_DATA: 'Keine Einsatzkräfte gefunden.',
    CHAT: 'Chat',
    ALERTS: 'Warnungen',
    ALERTS_NO_DATA: 'Keine Warnungen vom System generiert.',
    UPDATES: 'Aktualisierungen',
    UPDATES_NO_DATA: 'Keine Aktualisierungen zu Vorfällen oder Einsatzkräften.',
    NEW_MESSAGE_FROM: 'Neue Nachricht von',
    INCIDENT_UPDATED_BY: 'Vorfall aktualisiert von',
    NEW_INCIDENT_CREATED_BY: 'Neuer Vorfall erstellt von',
    PROFILE: 'Profil',
    SUMMARY: 'Zusammenfassung',
    GENERATING_SUMMARY: 'Zusammenfassung wird erstellt...',
  },

  INCIDENTS_PANEL: {
    INCIDENT_NAME: 'Vorfallname',
    INCIDENT_TYPE: 'Vorfallstyp',
    ASSIGNEES: 'Zugewiesene(r)',
    SEVERITY: 'Schweregrad',
    STATUS: 'Status',
    STATUS_HISTORY: 'Statusverlauf',
    SHOW: 'Anzeigen',
    SHOW_LESS: 'Weniger anzeigen',
    MORE: 'mehr',
    PTT: 'PTT',
    LOCATION: 'Ort',
    SEVERITY_CRITICAL: 'kritisch',
    SEVERITY_HIGH: 'hoch',
    SEVERITY_MEDIUM: 'mittel',
    SEVERITY_LOW: 'niedrig',
    SEVERITY_MINIMAL: 'minimal',
    REPORTED_DATE_TIME: 'Gemeldetes Datum und Uhrzeit',
    REPORTED_NAME: 'Name des Meldenden',
    DESCRIPTION: 'Beschreibung',
    RESPONDERS: 'Einsatzkräfte',
    ATTACHMENTS: 'Anhänge',
    LOCATION_DESCRIPTION: 'Ortsbeschreibung',
    NO_RESPONDERS_ASSIGNED: 'Keine Einsatzkräfte für den Vorfall zugewiesen.',
    CREATE_INCIDENT: 'Vorfall erstellen',
    EDIT_INCIDENT: 'Vorfall bearbeiten',
    SELECT_RESPONDERS: 'Einsatzkräfte auswählen',
    COMPLETE: 'Abschließen',
    CANCEL: 'Abbrechen',
    SAVE: 'Änderungen speichern',
    NO: 'Nein',
    DATA_FOUND: 'Daten gefunden',
    NO_OPTIONS: 'Keine Optionen verfügbar',
    AI_ASSISTANCE: 'KI-Unterstützung',
  },

  TAB_KEYS: {
    ALL: 'alle',
    UNREAD: 'ungelesen',
    ACTIVE: 'aktiv',
    CLOSED: 'geschlossen',
    AVAILABLE: 'verfügbar',
    OFFLINE: 'offline',
    TAB_VALUE_UNACKNOWLEDGED: 'nicht bestätigt',
    TAB_VALUE_CREATED: 'erstellt',
    TAB_VALUE_PROGRESS: 'in Bearbeitung',
    TAB_VALUE_RESOLVED: 'gelöst',
  },

  UPDATES_PANEL: {
    UPDATES: 'Aktualisierungen',
    MARK_AS_READ: 'Alle als gelesen markieren',
    ALL: 'Alle',
    UNREAD: 'Ungelesen',
    ALL_KEY: 'all',
    UNREAD_KEY: 'unread',
    NO_NOTIFICATIONS: 'Keine Benachrichtigungen',
    NO_UNREAD_NOTIFICATIONS: 'Keine ungelesenen Benachrichtigungen',
    UPDATE_STATUS: 'Status aktualisieren:',

    // Notification titles
    NEW_INCIDENT_TITLE: 'Neuer Vorfall',
    UPDATE_TITLE: 'Aktualisierung',

    CREATED_AT: 'erstellt am',

    // Status labels
    STATUS_CLOSED: 'Geschlossen',
    STATUS_IN_PROGRESS: 'In Bearbeitung',

    // Change descriptions
    STATUS_CHANGE: 'Status',
    SEVERITY_CHANGE: 'Schweregrad',
    TYPE_CHANGE: 'Typ',
    DESCRIPTION_UPDATED: 'Beschreibung aktualisiert',
    RESPONDERS_ADDED: 'Einsatzkraft/Einsatzkräfte hinzugefügt',
    RESPONDERS_REMOVED: 'Einsatzkraft/Einsatzkräfte entfernt',
    RESPONDERS_UPDATED: 'Einsatzkräfte aktualisiert',
    LOCATION_CHANGED: 'Standort geändert',
    UPDATED_DEFAULT: 'Aktualisiert',

    //Time
    UNKNOWN: 'Unbekannt',
    JUST_NOW: 'gerade eben',
    MINUTES_AGO: 'vor {{count}} Min.',
    MINUTES_AGO_plural: 'vor {{count}} Min.',
    HOURS_AGO: 'vor {{count}} Stunde',
    HOURS_AGO_plural: 'vor {{count}} Stunden',
    DAYS_AGO: 'vor {{count}} Tag',
    DAYS_AGO_plural: 'vor {{count}} Tagen',

    // Default values
    DEFAULT_TYPE: 'Vorfall',
    UNKNOWN_LOCATION: 'Unbekannter Standort',
  },

  MAP_VIEW: {
    INCIDENT_TOOLTIP: {
      INCIDENTTYPE: 'Art des Vorfalls',
      REPORTEDDATE: 'Meldedatum',
      SEVERITY: 'Schweregrad',
      STATUS: 'Status',
      RESPONDERS: 'Einsatzkräfte',
      NO_RESPONDERS: 'Keine Einsatzkräfte verfügbar',
    },
    INCIDENT_CLUSTER_TOOLTIP: {
      INCIDENTS: 'Vorfälle',
      MORE: 'mehr...',
    },
    MAP_FILTER: {
      VIEW_MODE: 'Ansichtsmodus',
      DEFAULT: 'Standard',
      SATELLITE: 'Satellit',
      FILTER_BY: 'Filtern nach',
      ALL: 'alle',
      ACTIVE: 'Aktiv',
      COMPLETED: 'Abgeschlossen',
      RESPONDERS: 'Einsatzkräfte',
      AVAILABLE: 'verfügbar',
    },
  },
  FALLBACK_SCREEN: {
    NO: 'Nein',
    DATA_FOUND: 'Daten gefunden',
    CREATE_INCIDENT: 'Vorfall erstellen',
    NO_AVAILABLE_RESPONDER_FOUND: 'Kein verfügbarer Einsatzleiter gefunden',
  },

  PERMISSION_DIALOG: {
    MICROPHONE: {
      TITLE: 'Mikrofonzugriff erforderlich',
      DESCRIPTION: 'Diese Anwendung benötigt Zugriff auf Ihr Mikrofon, um ordnungsgemäß zu funktionieren.',
      INSTRUCTION: 'Bitte gewähren Sie die Mikrofonberechtigung, um die App weiter zu verwenden.',
      BUTTON_LABEL: 'Mikrofonberechtigung erteilen',
    },
    CAMERA: {
      TITLE: 'Kamerazugriff erforderlich',
      DESCRIPTION: 'Diese Anwendung benötigt Zugriff auf Ihre Kamera, um ordnungsgemäß zu funktionieren.',
      INSTRUCTION: 'Bitte gewähren Sie die Kameraberechtigung, um die App weiter zu verwenden.',
      BUTTON_LABEL: 'Kameraberechtigung erteilen',
    },
    NOTIFICATIONS: {
      TITLE: 'Benachrichtigungsberechtigung erforderlich',
      DESCRIPTION: 'Diese Anwendung benötigt die Berechtigung, Ihnen Benachrichtigungen zu senden.',
      INSTRUCTION: 'Bitte gewähren Sie die Benachrichtigungsberechtigung, um die App weiter zu verwenden.',
      BUTTON_LABEL: 'Benachrichtigungsberechtigung erteilen',
    },
    GEOLOCATION: {
      TITLE: 'Standortzugriff erforderlich',
      DESCRIPTION: 'Diese Anwendung benötigt Zugriff auf Ihren Standort, um ordnungsgemäß zu funktionieren.',
      INSTRUCTION: 'Bitte gewähren Sie die Standortberechtigung, um die App weiter zu verwenden.',
      BUTTON_LABEL: 'Standortberechtigung erteilen',
    },
    HEADINGS: {
      WHAT_TO_DO: 'Was Sie tun müssen:',
      ADDITIONAL_REQUIRED: 'Zusätzliche Berechtigungen erforderlich',
      GENERIC_PERMISSION_TITLE: 'Berechtigung erforderlich',
      GENERIC_DESCRIPTION: 'Diese Anwendung benötigt zusätzliche Berechtigungen, um ordnungsgemäß zu funktionieren.',
      GENERIC_INSTRUCTION: 'Bitte gewähren Sie die erforderlichen Berechtigungen, um fortzufahren.',
    },
    DEFAULT_BUTTON_LABEL: 'Berechtigung erteilen',
  },
  SETTINGS: {
    TITLE: 'Einstellungen',
    SUBTITLE: 'Verwalte deine Sprach- und Übersetzungseinstellungen',
    LANGUAGE_DISPLAY: 'Anzeigesprache',
    AUTO_TRANSLATE_TITLE: 'Automatische Übersetzung aktivieren',
    AUTO_TRANSLATE_DESCRIPTION: 'Eingehende Nachrichten automatisch in deine ausgewählte Sprache übersetzen.',
    SAVE_BUTTON: 'Speichern',
    SELECT_PLACEHOLDER: 'Option auswählen...',
  },

  SOS_MODAL: {
    TITLE_ALERT_TRIGGERED: 'SOS-Alarm aktiviert',
    LOCATION_LABEL: 'Standort',
    INCIDENT_LABEL: 'Vorfall',
    LAST_STATUS_LABEL: 'Letzter Status',
    ASSIST_BUTTON: 'Helfen',
  },

  HEADER: {
    USERNAME: 'Benutzername',
    MODE: 'Modus',
    SETTINGS: 'Einstellungen',
    LOG_OUT: 'Abmelden',
    TITLE: 'AGIL Field Ops',
  },

  ERRORS: {
    INVALID_CHAT_DATA: 'Ungültige Chat-Daten',
    SUMMARY_GENERATION_FAILED: 'Zusammenfassungserstellung fehlgeschlagen:',
    FAILED_TO_GENERATE_SUMMARY: 'Zusammenfassung konnte nicht erstellt werden.',
    PLEASE_TRY_AGAIN: 'Bitte versuchen Sie es erneut.',
    UNKNOWN: 'Unbekannt',
    IN_PROGRESS_STATUS_ERROR: 'Mindestens ein Einsatzleiter muss zugewiesen sein, wenn der Status "In Bearbeitung" ist',
    RESOLVED_STATUS_ERROR: 'Mindestens ein Einsatzleiter muss zugewiesen sein, bevor der Vorfall geschlossen wird',
    SELECT_ONE_RESPONDER_ERROR: 'Bitte wählen Sie mindestens einen Einsatzleiter aus',
    WAIT_BEFORE_SUBMIT_AGAIN: 'Bitte warten Sie, bevor Sie erneut absenden',
    INCIDENT_CREATION_SERVICE_UNAVAILABLE:
      'Der Vorfall-Erstellungsdienst ist nicht verfügbar. Bitte versuchen Sie es später erneut.',
    NO_CHANGES_TO_UPDATE: 'Keine Änderungen zum Aktualisieren',
    FAILED_TO_UPDATE_INCIDENT:
      'Aktualisierung des Vorfalls fehlgeschlagen. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
    FAILED_TO_CREATE_INCIDENT:
      'Erstellung des Vorfalls fehlgeschlagen. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  },

  INCIDENT_TYPES: [
    { value: 'Medical', label: 'Medizinisch' },
    { value: 'Car accident', label: 'Autounfall' },
    { value: 'Fire', label: 'Feuer' },
    { value: 'Patrol', label: 'Streife' },
  ],

  SEVERITY_VALUES: [
    { value: 4, label: 'Kritisch', dotColor: 'bg-icon-error' },
    { value: 3, label: 'Hoch', dotColor: 'bg-chart-2' },
    { value: 2, label: 'Mittel', dotColor: 'bg-chart-4' },
    { value: 1, label: 'Niedrig', dotColor: 'bg-interactive' },
    { value: 0, label: 'Minimal', dotColor: 'bg-icon-muted' },
  ],

  INCIDENT_CARD_STATUS_VALUES: [
    { value: 'created', label: 'Erstellt' },
    { value: 'progress', label: 'In Bearbeitung' },
    { value: 'resolved', label: 'Gelöst' },
  ],

  CREATE_INCIDENT_STATUS_VALUES: [
    { value: 'open', label: 'Erstellt' },
    { value: 'in_progress', label: 'In Bearbeitung', disabled: false },
  ],

  EDIT_INCIDENT_STATUS_VALUES: [
    { value: 'in_progress', label: 'In Bearbeitung' },
    { value: 'resolved', label: 'Geschlossen' },
  ],

  INCIDENT_DETAILS_STATUS_VALUES: [
    { value: 'created', label: 'Erstellt', disabled: true },
    { value: 'progress', label: 'In Bearbeitung', disabled: true },
    { value: 'resolved', label: 'Geschlossen', disabled: true },
  ],

  RESPONSE_STATUS: [
    { value: 'accepted', label: 'Akzeptiert' },
    { value: 'rejected', label: 'Abgelehnt' },
    { value: 'pending', label: 'Ausstehend' },
  ],

  ASSIGNEE_STATUS: [
    { value: 'not_started', label: 'Nicht gestartet' },
    { value: 'on_the_way', label: 'Unterwegs' },
    { value: 'reach_site', label: 'Am Einsatzort' },
    { value: 'enroute', label: 'Unterwegs' },
    { value: 'done', label: 'Erledigt' },
  ],

  RESPONDER_STATUS: [
    { value: 'Unacknowledged', label: 'Nicht bestätigt' },
    { value: 'Rejected', label: 'Abgelehnt' },
    { value: 'Arrived at scene', label: 'Am Einsatzort angekommen' },
    { value: 'On the way', label: 'Unterwegs' },
    { value: 'Aborted', label: 'Abgebrochen' },
    { value: 'Done', label: 'Erledigt' },
  ],

  WEEKDAYS: [
    { value: 'Sun', label: 'So' },
    { value: 'Mon', label: 'Mo' },
    { value: 'Tue', label: 'Di' },
    { value: 'Wed', label: 'Mi' },
    { value: 'Thu', label: 'Do' },
    { value: 'Fri', label: 'Fr' },
    { value: 'Sat', label: 'Sa' },
  ],
};
